import * as React from 'react';

import { Breadcrumbs } from '@coursera/cds-core';

import _t from 'i18n!nls/enterprise-learning-path-description-page';

type Props = {
  programSlug: string;
  programName: string;
};

const LearningPathBreadcrumbs = ({ programSlug, programName }: Props) => {
  return (
    <Breadcrumbs>
      <Breadcrumbs.Item href={`/programs/${programSlug}`}>{_t('All learning programs')}</Breadcrumbs.Item>
      <Breadcrumbs.Item href={`/programs/${programSlug}`}>{programName}</Breadcrumbs.Item>
    </Breadcrumbs>
  );
};

export default LearningPathBreadcrumbs;
